import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { removeUndefined } from 'diwimamodelweb/lib/utils/obejct-diff';
import { BaseSettingForm } from '../model/form';
import { SettingsService } from '../settings.service';
import { firstValueFrom, skipWhile, take } from 'rxjs';
import { NetworkConstants } from 'diwimamodelweb/lib';

export enum PickerMode {
  OPTIONAL = "optional", PREDEFINED = "predefined", MANDATORY = "mandatory", NONE = 'none' 
}

const validatorPersonSelect: ValidatorFn =
    (control: AbstractControl): ValidationErrors|null => {
      const personPickerModeControl = control.get('personPickerMode')
      const personControl = control.get('person')
      return personPickerModeControl.value == PickerMode.PREDEFINED && personControl.value == undefined ? {personRequired: true} : null
    }

@Component({
  selector: 'app-utilization-option-form',
  templateUrl: './utilization-option-form.component.html',
  styleUrls: ['./utilization-option-form.component.css', '../../app.component.scss']
})
export class UtilizationOptionFormComponent implements OnInit {

  @Input() data: BaseSettingForm
  @Input() formBuilder: FormBuilder
  @Input() translateService: TranslateService

  deleteRight = false
  updateRight = false
  utilizationOptionsForm: FormGroup
  isCreate = false
  showPersonSelect = false

  constructor(private settingsService: SettingsService) { }

  async ngOnInit(): Promise<void> {

    const context = await firstValueFrom(this.settingsService.selectedUserContext$.pipe(
      skipWhile(el => !el),
      take(1)
    ))
    const rights = this.settingsService.rightsPercontext.get(context.identifier)
    this.updateRight = !rights?.[NetworkConstants.ROUTE_CTX_SETTINGS]?.['U'] ?? false
    this.deleteRight = !rights?.[NetworkConstants.ROUTE_CTX_SETTINGS]?.['D'] ?? false

    if (!this.data.data) this.isCreate = true
    this.utilizationOptionsForm = this.formBuilder.group({
      title: [, Validators.required],
      personPickerMode:[, Validators.required],
      person: []
    }, {validators: [validatorPersonSelect]})
    if(this.data.data) this.initilaizeWithData()
    this.utilizationOptionsForm.valueChanges.subscribe((value) => {
      const {title, personPickerMode, person} = value
      if (!this.isCreate) {} 
      this.showPersonSelect = personPickerMode == PickerMode.PREDEFINED
      if (personPickerMode != PickerMode.PREDEFINED) {
        if (this.data.data?.personId) this.data.data.personId = undefined
        if (this.data.data?.personName) this.data.data.personName = undefined
      }
    })
  }

  initilaizeWithData() {
    const {title, personPickerMode, personId} = this.data.data
    const person = this.data.person?.find(el => el.identifier == personId)
    const pp = personPickerMode ? personPickerMode : 'none'
    this.utilizationOptionsForm.patchValue({title, personPickerMode: pp, person})
    if (personPickerMode == PickerMode.PREDEFINED) this.showPersonSelect = true
  }

  onSubmit() {
    const {title, personPickerMode, person} = this.utilizationOptionsForm.value
    const pp = (personPickerMode == PickerMode.NONE) ? undefined : personPickerMode
    if (this.isCreate) {
      let setting = {
        identifier: title, 
        title, 
        // personId: person.identifier,
        // personName: person.anzeigeName,
        // personPickerMode: pp
      }
      if (pp != PickerMode.NONE) {
        setting['personPickerMode'] = pp
      }
      if (person) {
        setting['personId'] = person.identifier
        setting['personName'] = person.anzeigeName
      }
      const cleaned = removeUndefined(setting)
      this.data.onCreate(cleaned)
    } else {
      // set data
      this.data.data.title = title
      if (person) {
        this.data.data.personId = person.identifier
        this.data.data.personName = person.anzeigeName
      }
      if (personPickerMode == PickerMode.NONE) this.data.data.personPickerMode = undefined
      else this.data.data.personPickerMode = personPickerMode
      if (personPickerMode != PickerMode.PREDEFINED) {
        if (this.data.data?.personId) this.data.data.personId = undefined
        if (this.data.data?.personName) this.data.data.personName = undefined
      }
      this.data.data = removeUndefined(this.data.data)
      this.data.onSubmit()
    }
  }

  onDelete(){
    this.data.onDelete(this.data)
  }
}
